import { Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ReactElement } from "react";

import { PromptTemplateCreationParams, PromptTemplateScope } from "../../../types/prompt-template";
import { LensFormErrors } from "../utils";
import {
  ABOUT_OPTIONS,
  AUDIENCE_OPTIONS,
  CATEGORY_OPTIONS,
  PRIMARY_FUNCTION_OPTIONS
} from "../constants";
import FormSelectField from "./FormSelectField";
import ScopeSelectField from "./ScopeSelectField";

interface MetadataFormSectionProps {
  formData: PromptTemplateCreationParams;
  formErrors: LensFormErrors;
  onMetadataChange: (field: string, value: string) => void;
  onScopeChange: (value: PromptTemplateScope[]) => void;
}

const MetadataFormSection = ({
  formData, formErrors, onMetadataChange, onScopeChange
}: MetadataFormSectionProps): ReactElement => (
  <>
    <Grid size={{ xs: 12 }}>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ mb: 2 }}>Metadata</Typography>
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <FormSelectField
        label="Category"
        value={formData.metadata.category}
        options={CATEGORY_OPTIONS}
        error={formErrors["metadata.category"]}
        onChange={(v): void => onMetadataChange("category", v)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <FormSelectField
        label="About"
        value={formData.metadata.about}
        options={ABOUT_OPTIONS}
        error={formErrors["metadata.about"]}
        onChange={(v): void => onMetadataChange("about", v)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <FormSelectField
        label="Audience"
        value={formData.metadata.audience}
        options={AUDIENCE_OPTIONS}
        error={formErrors["metadata.audience"]}
        onChange={(v): void => onMetadataChange("audience", v)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <FormSelectField
        label="Primary Function"
        value={formData.metadata.primary_function}
        options={PRIMARY_FUNCTION_OPTIONS}
        error={formErrors["metadata.primary_function"]}
        onChange={(v): void => onMetadataChange("primary_function", v)}
      />
    </Grid>
    <ScopeSelectField scope={formData.metadata.scope} error={formErrors["metadata.scope"]} onScopeChange={onScopeChange} />
  </>
);

export default MetadataFormSection;
